// extracted by mini-css-extract-plugin
export var aiStarIcon = "_m9-2";
export var container = "_m9-4";
export var dismissButton = "_m9-3";
export var hasPaddingBottom = "_m9-6";
export var last = "_m9-e";
export var scrollbarThumb = "_m9-c";
export var scrollbarTrack = "_m9-b";
export var selected = "_m9-9";
export var spin = "_m9-1";
export var spinning = "_m9-0";
export var suggestionItem = "_m9-d";
export var suggestionsPanel = "_m9-5";
export var tonePill = "_m9-8";
export var tonesContainer = "_m9-7";
export var unselected = "_m9-a";